import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Badge } from '@capawesome/capacitor-badge';

@Injectable({ providedIn: 'root' })
export class BadgeService {
  async clearBadge(): Promise<void> {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    try {
      await Badge.clear();
    } catch (error) {
      console.warn('Failed to clear badge:', error);
    }
  }

  async setBadge(count: number): Promise<void> {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    try {
      await Badge.set({ count });
    } catch (error) {
      console.warn('Failed to set badge:', error);
    }
  }

  async isSupported(): Promise<boolean> {
    if (!Capacitor.isNativePlatform()) {
      return false;
    }

    try {
      const { isSupported } = await Badge.isSupported();
      return isSupported;
    } catch (error) {
      return false;
    }
  }
}
